import axios from 'axios'
import services from '@/config/services'
import authHeader from '@/services/auth/auth-header'

export default class ExportContabilitaService {
  constructor(http, eventBus) {
    this.http = http || axios
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_pratiche_base.url}/api/contabilita-files/impn/exports`

    axios.interceptors.request.use((req) => {
      req.headers['Authorization'] = authHeader()
      return req
    })
  }

  async getIncassi(params = {}) {
    return await this.getExportsByTipo('incassi', params)
  }

  async getVendite(params = {}) {
    return await this.getExportsByTipo('vendite', params)
  }

  async getMovimenti(params = {}) {
    return await this.getExportsByTipo('movimenti', params)
  }

  async getExportsByTipo(tipo, params = {}) {
    const res = await this.http.get(this.baseUrl, {
      params: {
        tipo,
        ...params,
      },
    })

    return res.data
  }

  async downloadFile(row) {
    const url = `${this.baseUrl}/${row.id}/download`

    const response = await this.http.get(url, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data])
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = downloadUrl
    link.download = row.filename || 'download'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(downloadUrl)

    return response
  }
}